export const GET_WHATS_NEW_START = 'WHATS_NEW_GET_START';
export const GET_WHATS_NEW_SUCCESS = 'WHATS_NEW_GET_SUCCESS';
export const GET_WHATS_NEW_FAIL = 'WHATS_NEW_GET_FAIL';
